import { Goal } from '../../goals';
import { GoalFieldsFragment } from '../../graphql/generated';

export function goalsFromFragments(
    fragments?: GoalFieldsFragment[] | null
): Goal[] {
    if (!fragments || !Array.isArray(fragments)) return [];
    // @ts-expect-error TODO: Try to improve the typing here
    return fragments.filter((g) => !g.deletedAt);
}
